<template>
  <v-col
    cols="12"
    class="pb-0 pt-0"
  >
    <v-card
      id="main-card"
      text
      color
    >
      <v-row class="grey lighten-4">
        <v-col
          v-resize="handleHeight"
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-row
            class="grey lighten-4"
            no-gutters
          >
            <v-col cols="8">
              <v-toolbar
                flat
                class="grey lighten-4"
                height="48px"
              >
                <v-btn
                  v-if="hasWritePermissions"
                  :loading="saveLoadingButton"
                  :disabled="saveLoadingButton || !functionDeployed && deployingFunction"
                  outlined
                  :color="isReadyToSave?'green white--text':''"
                  @click="handleSave()"
                >
                  <v-icon small>
                    mdi-content-save-outline
                  </v-icon>&nbsp; Save
                  <span slot="loader">Saving...</span>
                </v-btn>
                <v-btn
                  v-if="hasReadPermissions"
                  id="run-button"
                  :disabled="runLoadingButton"
                  outlined
                  class="ml-5"
                  @click.native="appendCodeBlock"
                >
                  <v-icon small>
                    mdi-plus-circle-outline
                  </v-icon>&nbsp; add block
                </v-btn>
                <v-btn
                  v-if="hasReadPermissions"
                  id="run-button"
                  :loading="runLoadingButton || isExecuting"
                  :disabled="runLoadingButton"
                  outlined
                  class="mx-5"
                  @click.native="invokeCode"
                >
                  <v-icon small>
                    mdi-play
                  </v-icon>&nbsp; Run all
                </v-btn>
                <v-switch
                  v-model="this.async"
                  id="async-switch"
                  v-if="hasReadPermissions"
                  :label="'Async'"
                  :disabled="runLoadingButton || isExecuting"
                  @change="changeSync()"
                  class="mt-5"
                ></v-switch>
                <span v-if="!isRequestDataJsonFormat && useDataInFunction">Request data is invalid</span>
                <span v-if="!functionDeployed && deployingFunction">Deploying...</span>
                <v-spacer />
                <v-slide-x-transition>
                  <div v-if="activeBlockIndex!=null">
                    <v-menu
                      v-model="codeTypeMenuIsVisible"
                      :disabled="isInterruptable"
                      bottom
                      left
                      small
                    >
                      <template #activator="{on:onMenu}">
                        <v-tooltip top>
                          <template #activator="{on:onTooltip}">
                            <v-btn
                              depressed
                              fab
                              x-small
                              class="mr-2 elevation-3"
                              color="primary"
                              :disabled="isInterruptable"
                              v-on="{ ...onMenu, ...onTooltip }"
                            >
                              <v-icon>
                                mdi-{{
                                  codeBlocks[activeBlockIndex].cell_type == 'code' ? 'code':'markdown'
                                }}
                                mdi-code-braces
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Type (Code/Markdown)</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item-group v-model="codeBlocks[activeBlockIndex].cell_type">
                          <v-list-item value="code">
                            <v-list-item-title>
                              <v-icon left>
                                mdi-code-braces
                              </v-icon>Code
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item value="markdown">
                            <v-list-item-title>
                              <v-icon left>
                                mdi-markdown
                              </v-icon>Markdown
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-btn
                          v-if="codeBlocks[activeBlockIndex].cell_type=='markdown' && !_.isEmpty(codeBlocks[activeBlockIndex].outputs)"
                          depressed
                          fab
                          x-small
                          class="mr-2 elevation-3"
                          color="blue lighten-1 white--text"
                          :loading="isExecuting"
                          v-on="on"
                          @click="codeBlocks[activeBlockIndex].cell_type === 'markdown'?codeBlocks[activeBlockIndex].outputs = []:false"
                        >
                          <v-icon>mdi-comment-edit</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          depressed
                          fab
                          x-small
                          class="mr-2 elevation-3"
                          :color="isInterruptable ?'red white--text':'secondary'"
                          :loading="isExecuting"
                          v-on="on"
                          @click="isInterruptable ? interruptFunctionCodeBlock() :executeFunctionCodeBlock() "
                        >
                          <v-icon>{{ isInterruptable?'mdi-stop':'mdi-play' }}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ codeBlocks[activeBlockIndex].cell_type=='markdown' && !_.isEmpty(codeBlocks[activeBlockIndex].outputs) ? 'Edit' : 'Run (CTRL+Enter)' }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-btn
                          depressed
                          fab
                          x-small
                          color="red lighten-2 white--text"
                          class="elevation-3"
                          :disabled="isInterruptable"
                          v-on="on"
                          @click="removeFunctionCodeBlock"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      Delete
                    </v-tooltip>
                  </div>
                </v-slide-x-transition>
              </v-toolbar>

              <!-- top bar (save, run, runtime info) END -->
            </v-col>
            <v-col
              cols="4"
              class="text-right"
            >
              <v-spacer />
              <v-progress-circular
                v-if="!functionDeployed && deployingFunction"
                indeterminate
                class="mr-5"
                color="primary"
              />

              <v-btn
                class="mr-4"
                right
                text
                @click="rightMenuVisible=!rightMenuVisible"
              >
                <v-icon left>
                  mdi-eye{{ rightMenuVisible?'-off':'' }}
                </v-icon>
                {{ rightMenuVisible?'Hide':'Show' }} samples
              </v-btn>
              <v-btn
                id="runtime-button"
                text
                outlined
                class="running"
                small
              >
                {{ hmdFunction.runtime }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <!-- editor START -->
            <v-col
              cols="12"
              sm="12"
              :md="rightMenuVisible?7:12"
              :lg="rightMenuVisible?8:12"
              :style="'height:'+(windowHeight-330)+'px;overflow:auto;'"
            >
              <draggable
                :list="codeBlocks"
                handle=".move-function-code-block"
              >
                <transition-group>
                  <function-code-block
                    v-for="(block,index) in codeBlocks"
                    :key="index"
                    v-model="codeBlocks[index]"
                    class="mb-4"
                    :is-active="activeBlockIndex == index"
                    :lang="hmdFunction.lang"
                    :is-executing="isExecuting || (isExecutingBlock && activeBlockIndex == index)"
                    @isActive="activeBlockIndex = index"
                    @remove="codeBlocks.splice(codeBlocks.indexOf(block),1)"
                    @execute="executeFunctionCodeBlock(index)"
                  />
                </transition-group>
              </draggable>
            </v-col>
            <!-- editor END -->

            <!-- right side menu START -->
            <v-col
              v-if="hasWritePermissions && rightMenuVisible"
              cols="12"
              sm="12"
              md="5"
              lg="4"
            >
              <v-tabs
                v-model="activeTab"
                grow
                background-color="grey lighten-3"
              >
                <v-tab
                  v-if="rightMenuVisible"
                  height="500px"
                >
                  Templates
                </v-tab>
                <v-tab
                  v-if="rightMenuVisible"
                  @click="handleClickData"
                >
                  Data
                </v-tab>
                <v-tab
                  v-if="rightMenuVisible"
                  @click="handleClickApi"
                >
                  Api
                </v-tab>
                <v-tab-item
                  v-for="(item, index) in ['templates', 'data', 'api']"
                  :key="index"
                  background-color="grey lighten-4"
                >
                  <!-- Templates template START -->
                  <template v-if="item === 'templates'">
                    <v-col
                      cols="12"
                      style="background-color: whitesmoke"
                    >
                      <!-- panel with existing templates START -->
                      <template v-if="templatesProp.length > 0">
                        <v-row class="height">
                          <!-- search START -->
                          <v-col cols="12">
                            <v-text-field
                              v-model="searchTemplate"
                              label="Name contains"
                              prepend-icon="mdi-magnify"
                              class="mx-3 mt-n5 mb-n5"
                            />
                          </v-col>
                          <!-- search END -->
                        </v-row>

                        <!-- templates START -->
                        <v-container
                          fluid
                          class="pa-0"
                        >
                          <v-row>
                            <v-col style="overflow-y: auto; min-height: 361px; max-height: 361px;">
                              <v-expansion-panels
                                :accordion="true"
                                :focusable="true"
                              >
                                <v-expansion-panel
                                  v-for="(method,i) in templates"
                                  :key="i"
                                  class="grey lighten-4"
                                >
                                  <v-expansion-panel-header>{{ method.name }}</v-expansion-panel-header>
                                  <v-expansion-panel-content class="grey lighten-4">
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12">
                                          <div class="caption">
                                            {{ method.description }}
                                          </div>
                                        </v-col>
                                        <v-col cols="12">
                                          <editor
                                            v-model="method.content"
                                            class="caption"
                                            :lang="hmdFunction.lang"
                                            theme="chrome"
                                            width="100%"
                                            height="200px"
                                            :options="options"
                                            @init="editorInit"
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                    <v-row
                                      align="center"
                                      justify="center"
                                    >
                                      <v-btn
                                        small
                                        color="primary"
                                        @click.native="addCode(method)"
                                      >
                                        Insert
                                      </v-btn>
                                    </v-row>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-col>
                          </v-row>
                        </v-container>
                        <!-- templates END -->

                        <!-- button START -->
                        <v-btn
                          block
                          color="primary"
                          style="margin-top:1px;"
                          class="mt-1"
                          @click.native="dialog=true"
                        >
                          new template
                        </v-btn>
                        <!-- button END -->
                      </template>
                      <!-- panel with existing templates END -->

                      <!-- panel with no existing templates START -->
                      <template v-else>
                        <v-col>
                          <p
                            class="text-center"
                            style="font-size:15px;margin-top:35px;"
                          >
                            No template defined.
                            <br>
                            <a
                              href="#"
                              @click.prevent="dialog=true"
                            >Create one now !</a>
                          </p>
                        </v-col>
                      </template>
                      <!-- panel with no existing templates END -->

                      <!-- Template creation dialog START -->
                      <v-dialog
                        v-model="dialog"
                        max-width="800"
                        persistent
                      >
                        <v-card>
                          <v-row>
                            <v-col cols="9">
                              <v-card-title class="headline">
                                Template creation
                              </v-card-title>
                            </v-col>
                            <v-col cols="3">
                              <v-card-title>
                                <v-btn
                                  text
                                  dark
                                  outlined
                                  color="primary"
                                  small
                                >
                                  {{ hmdFunction.runtime }}
                                </v-btn>
                              </v-card-title>
                            </v-col>
                            <v-card-text>
                              <v-col cols="4">
                                <v-text-field
                                  v-model="newTemplate.name"
                                  v-validate="'required|min:3|alpha_dash'"
                                  label="name"
                                  :error-messages="errors.collect('name')"
                                  data-vv-name="name"
                                  required
                                />
                              </v-col>
                              <v-textarea
                                v-model="newTemplate.description"
                                label="description"
                                outlined
                                rows="2"
                              />
                              <v-col cols="12">
                                <v-text-field
                                  v-model="newTemplate.dependencies"
                                  label="Dependencies"
                                  hint="Enter dependencies you need"
                                />
                              </v-col>
                              <editor
                                v-model="newTemplate.content"
                                :lang="hmdFunction.lang"
                                theme="chrome"
                                width="100%"
                                height="250px"
                                :options="options"
                                @init="editorInit"
                              />
                              <v-row>
                                <v-col cols="4">
                                  <v-switch
                                    v-model="newTemplate.privacy_status"
                                    :label="newTemplate.privacy_status ? 'private' : 'public'"
                                  />
                                </v-col>
                                <v-spacer />
                                <v-col cols="4">
                                  <v-btn
                                    text
                                    @click.native="dialog=false"
                                  >
                                    close
                                  </v-btn>
                                  <v-btn
                                    text
                                    @click.native="createTemplate"
                                  >
                                    create
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-row>
                        </v-card>
                      </v-dialog>
                      <!-- Template creation dialog END -->
                    </v-col>
                  </template>
                  <!-- Templates template END -->

                  <!-- Data template START -->
                  <template v-if="item === 'data'">
                    <v-col
                      cols="12"
                      style="background-color: whitesmoke"
                    >
                      <!-- panel with existing data END -->
                      <template v-if="datasetsList.length > 0 || callingBackendData">
                        <v-row class="height">
                          <!-- search START -->
                          <v-col cols="12">
                            <v-text-field
                              v-model="searchData"
                              label="Name contains"
                              prepend-icon="mdi-magnify"
                              class="mx-3 mt-n5 mb-n5"
                            />
                          </v-col>
                          <!-- search END -->
                        </v-row>

                        <!-- data panel START -->
                        <v-container
                          fluid
                          class="pa-0"
                        >
                          <v-row>
                            <v-col cols="12">
                              <!-- Dataset list START -->
                              <v-list
                                id="data-list"
                                class="grey lighten-4"
                                style="overflow-y: auto; min-height: 361px; max-height: 361px;"
                              >
                                <v-list-item-group v-model="datasetListItemSelected">
                                  <v-list-item
                                    v-for="(dataset, i) in datasets"
                                    :key="i"
                                    :value="dataset.hmd_id"
                                    ripple
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title v-text="dataset.name" />
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                              <!-- Dataset list END -->

                              <!-- button START -->
                              <v-btn
                                block
                                color="primary"
                                :disabled="!datasetListItemSelected"
                                @click="handleClickInsertDataset"
                              >
                                Insert dataset
                              </v-btn>
                              <!-- button END -->
                            </v-col>
                          </v-row>
                        </v-container>
                        <!-- data panel END -->
                      </template>
                      <!-- panel with existing data END -->

                      <!-- panel with no existing data START -->
                      <template v-else>
                        <v-col>
                          <p
                            class="text-center"
                            style="font-size:15px;margin-top:35px;"
                          >
                            No dataset available.
                            <br>
                            <router-link :to="{name: 'New dataset'}">
                              Create one now !
                            </router-link>
                          </p>
                        </v-col>
                      </template>
                      <!-- panel with no existing data END -->
                    </v-col>
                  </template>
                  <!-- Data template END -->

                  <!-- Api template START -->
                  <template v-if="item === 'api'">
                    <v-col
                      cols="12"
                      style="background-color: whitesmoke"
                    >
                      <!-- panel with existing api START -->
                      <template v-if="apiList.length > 0 || callingBackendApi">
                        <v-row class="height">
                          <!-- search START -->
                          <v-col cols="12">
                            <v-text-field
                              v-model="searchApi"
                              label="Name contains"
                              prepend-icon="mdi-magnify"
                              class="mx-3 mt-n5 mb-n5"
                            />
                          </v-col>
                          <!-- search END -->
                        </v-row>

                        <!-- api panel START -->
                        <v-container
                          fluid
                          class="pa-0"
                        >
                          <v-row>
                            <v-col cols="12">
                              <!-- Api list START -->
                              <v-list
                                id="api-list"
                                class="grey lighten-4"
                                style="overflow-y: auto; min-height: 361px; max-height: 361px;"
                              >
                                <v-list-item-group v-model="apiListItemSelected">
                                  <v-list-item
                                    v-for="(api, i) in apis"
                                    :key="i"
                                    :value="api.name"
                                    ripple
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title v-text="api.name" />
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                              <!-- Api list END -->

                              <!-- button START -->
                              <v-btn
                                block
                                color="primary"
                                :disabled="!apiListItemSelected"
                                @click="handleClickInsertApi"
                              >
                                Insert api
                              </v-btn>
                              <!-- button END -->
                            </v-col>
                          </v-row>
                        </v-container>
                        <!-- api panel END -->
                      </template>
                      <!-- panel with existing api END -->

                      <!-- panel with no existing api START -->
                      <template v-else>
                        <v-col>
                          <p
                            class="text-center"
                            style="font-size:15px;margin-top:35px;"
                          >
                            No API defined.
                            <br>
                            <router-link :to="{name: 'New api'}">
                              Create one now !
                            </router-link>
                          </p>
                        </v-col>
                      </template>
                      <!-- panel with no existing api END -->
                    </v-col>
                  </template>
                  <!-- Api template END -->
                </v-tab-item>
              </v-tabs>
            </v-col>
            <!-- right side menu END -->
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
  import FunctionService from './services/FunctionService'
  import FunctionCodeBlock from './FunctionCodeBlock'
  import VueJsonPretty from 'vue-json-pretty'
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable,
      FunctionCodeBlock,
      editor: require('vue2-ace-editor-readonly'),
      VueJsonPretty,
    },
    props: {
      hmdFunction: {
        type: Object,
        default: () => {
          return {}
        },
      },
      saveLoadingButton: Boolean,
      templatesProp: Array,
    },
    data: function () {
      return {
        windowHeight: window.innerHeight,
        //   Newly delevoped objects
        codeBlocksOld: [],
        codeBlockTemplate: {
          cell_type: 'code',
          source: '',
          execution_count: 0,
          outputs: [],
          metadata: {},
        },
        activeBlockIndex: null,
        codeBlocks: [
          {
            cell_type: 'code',
            source: '',
            execution_count: 0,
            outputs: [],
            metadata: {},
          },
        ],
        // Old objects
        menuItems: [],
        options: {
          fontSize: '12pt',
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          showLineNumbers: false,
          tabSize: 2,
        },
        dialog: false,
        loader: null,
        isExecuting: false,
        isExecutingBlock: false,
        codeTypeMenuIsVisible: false,
        runLoadingButton: false,
        rightMenuVisible: true,
        newTemplate: {
          name: '',
          description: '',
          dependencies: '',
          content: '',
          runtime: '',
          privacy_status: true,
        },
        result: 'Run your function to see the result.',
        functionDeployed: false,
        deployingFunction: false,
        showSearchTemplates: false,
        showSearchData: false,
        showSearchApi: false,
        searchTemplate: '',
        datasetsList: [],
        datasetListItemSelected: undefined,
        searchData: '',
        apiList: [],
        apiListItemSelected: '',
        searchApi: '',
        interval: '',
        activeTab: 0,
        activeTabConsole: 0,
        requestData: '',
        useDataInFunction: false,
        isRequestDataJsonFormat: false,
        logs: null,
        logsDisplayed: false,
        showLogBtn: true,
        showRelaunchBtn: false,
        scrolled: false,
        eventify: '',
        callingBackendData: false,
        callingBackendApi: false,
        event:null,
        async:false,
      }
    },
    computed: {
      isInterruptable () {
        return this.isExecuting || this.isExecutingBlock
      },
      isReadyToSave () {
        // source + cell_type
        const limit = o => {
          return { source: o.source, cell_type: o.cell_type }
        }
        const rep = !_.isEqual(
          this.codeBlocks.map(limit),
          this.codeBlocksOld.map(limit)
        )
        this.$emit(
          'updateCloseConstraint',
          rep ? 'Are you sure you want to quit without saving ?' : null
        )
        return rep
      },
      templates: function () {
        if (this.searchTemplate.length > 0) {
          return this.templatesProp.filter(template => {
            return template.name
              .toLowerCase()
              .includes(this.searchTemplate.toLowerCase())
          })
        } else {
          return this.templatesProp
        }
      },

      datasets: function () {
        if (this.searchData.length > 0) {
          return this.datasetsList.filter(dataset => {
            return dataset.name
              .toLowerCase()
              .includes(this.searchData.toLowerCase())
          })
        } else {
          return this.datasetsList
        }
      },
      apis: function () {
        if (this.searchApi.length > 0) {
          return this.apiList.filter(api => {
            return api.name.toLowerCase().includes(this.searchApi.toLowerCase())
          })
        } else {
          return this.apiList
        }
      },
      hasOwnerPermissions () {
        return this.hmdFunction.user_permissions.includes('owner_function') ||
        this.hmdFunction.user_permissions.includes('owner_project')
      },
      hasWritePermissions () {
        return this.hasOwnerPermissions ||
        this.hmdFunction.user_permissions.includes('read_write_function') ||
        this.hmdFunction.user_permissions.includes('read_write_project')
      },
      hasReadPermissions () {
        return this.hasWritePermissions ||
        this.hmdFunction.user_permissions.includes('read_function') ||
        this.hmdFunction.user_permissions.includes('read_project')
      },
    },
      created(){
        window.addEventListener('keydown', this.handleKeyDown, false)
      },
    mounted () {
      if (this.hmdFunction.content.cells.length < 0) {
        this.appendCodeBlock()
      }
      this.activeBlockIndex = 0

      this.codeBlocks = _.cloneDeep(this.hmdFunction.content.cells)
      this.codeBlocksOld = _.cloneDeep(this.hmdFunction.content.cells)
      // Key listener to handle Ctrl + S / Cmd + S

      // We check the function status when loading the page
      this.checkFunctionDeployed()
    },
    beforeDestroy: function () {
        window.removeEventListener('keydown', this.handleKeyDown, false)
        clearInterval(this.interval)
    },
    methods: {
      changeSync(){
        this.async = !this.async
      },
      removeFunctionCodeBlock () {
        const self = this

        // If block is empty dont display any warnings
        if (this.codeBlocks[self.activeBlockIndex].source.trim() == '') {
          self.codeBlocks.splice(self.activeBlockIndex, 1)
        } else { // Block not empty display some warnings
          this.$store.commit('confirm', {
            message: 'Do you really want to delete this code block ?',
            title: 'Warning',
            color: 'warning',
            onCancel: () => {},
            onConfirm: () => {
              // Bufferize the activeBlockIndex, because some stuff make reference
              // to a codeBlock and if it is deleted it will make some errors
              const buffActive = self.activeBlockIndex
              self.activeBlockIndex = 0
              self.codeBlocks.splice(buffActive, 1)
              // Maybe should we save the function after deleting one block ?
              // Or let the possibility to the user if it was a mistake to press
              // F5 and reload the page and the deleted page ???
            },
          })
        }
      },
      interruptFunctionCodeBlock () {
        FunctionService.interruptKernel(this.hmdFunction.id, this).then(r => {
          this.isExecuting = false
          this.isExecutingBlock = false
        })
      },
      executeFunctionCodeBlock () {
        const self = this
        if (self.codeBlocks[self.activeBlockIndex].cell_type === 'markdown') {
          self.codeBlocks[self.activeBlockIndex].outputs = [
            self.codeBlocks[self.activeBlockIndex].source,
          ]
          return
        }
        self.invokeCodeBlock(self.activeBlockIndex)
      },
      handleHeight (e) {
        if (e) {
          this.windowHeight = e.target.innerHeight
        }
      },
      editorInit: function () {
        require('brace/mode/python')
        require('brace/mode/sh')
        require('brace/mode/php')
        require('brace/mode/java')
        require('brace/mode/ruby')
        require('brace/theme/chrome')
      /*  require('brace/theme/solarized_dark') */
      },
      handlerChangeCode: function (code) {
        this.$emit('change', code)
      },
      handleSave: function () {
        FunctionService.deploy(this.hmdFunction, this.codeBlocks, this).then(
          () => {
            this.codeBlocksOld = _.cloneDeep(this.codeBlocks)
          }
        )

        // this.$emit('save')
        // this.functionDeployed = false
        // this.deployingFunction = true

        // const runTime = document.getElementById('runtime-button')
        // runTime.classList.remove('running', 'pending', 'crashLoopBackOff')
        // runTime.classList.add('pending')

        // clearInterval(this.interval)
        // this.interval = setInterval(this.checkFunctionDeployed, 6000)
      },
      appendCodeBlock () {
        this.codeBlocks.push(_.cloneDeep(this.codeBlockTemplate))
      },
      invokeCode () {
        var t = this
        t.isExecuting = true
        // TODO: if this.useDataInFunction === true use data this.requestData in function
        FunctionService.runFunction(
          this.hmdFunction.id,
          {
            cells: t.codeBlocks,
            async: this.async,
          },
          true,
          this
        )
          .then(function (response) {
            t.codeBlocks = response.data.cells
            t.result = response.data
            t.runLoadingButton = false
            t.activeTabConsole = 1 // respond
          })
          .catch(function (error) {
            t.result = error.response.data
            t.runLoadingButton = false
            t.activeTabConsole = 2 // logs
            t.displayLogs()
          })
          .finally(() => {
            t.isExecuting = false
          })
      },
      invokeCodeBlock (blockIndex) {
        var t = this
        // TODO: if this.useDataInFunction === true use data this.requestData in function
        t.isExecutingBlock = true
        FunctionService.runFunction(
          this.hmdFunction.id,
          {
            async: this.async,
            cells: [t.codeBlocks[blockIndex]],
          },
          true,
          this
        )
          .then(function (response) {
            t.codeBlocks[blockIndex].execution_count =
              response.data.cells[0].execution_count
            t.codeBlocks[blockIndex].outputs = response.data.cells[0].outputs
            if (
              t.activeBlockIndex < t.codeBlocks.length - 1 &&
              _.isEmpty(
                _.filter(response.data.cells[0].outputs, o =>
                  _.has(o, 'traceback')
                )
              )
            ) {
              t.activeBlockIndex++
            }
            t.result = response.data
            t.runLoadingButton = false
            t.activeTabConsole = 1 // respond
          })
          .catch(function (error) {
            t.result = error.response.data
            t.runLoadingButton = false
            t.activeTabConsole = 2 // logs
            t.displayLogs()
          })
          .finally(() => {
            t.isExecutingBlock = false
          })
      },
      runFunction () {
        this.runLoadingButton = true
        var t = this
        // TODO: if this.useDataInFunction === true use data this.requestData in function
        FunctionService.runFunction(
          this.hmdFunction.id,
          this.requestData,
          this.useDataInFunction,
          this
        )
          .then(function (response) {
            t.result = response.data
            t.runLoadingButton = false
            t.activeTabConsole = 1 // respond
          })
          .catch(function (error) {
            t.result = error.response.data
            t.runLoadingButton = false
            t.activeTabConsole = 2 // logs
            t.displayLogs()
          })
      },
      addCode (method) {
        // This function is used to insert code in the editor using a template or an api/dataset.
        // If it's for a template, we want to insert its content, which is undefined for an api/dataset
        // since in this case the parameter is already the text to insert
        var newContent = method.content === undefined ? method : method.content

        if (method.dependencies && method.dependencies != null) {
          var txtDependency =
            '#---------------------------------------------------------#\n'
          txtDependency +=
            '# Check your dependecies, for this template you need to add #\n'
          txtDependency += '# ' + method.dependencies + '\n'
          txtDependency +=
            '#---------------------------------------------------------#\n'
          newContent = txtDependency + method.content
        }

        var codeToAdd = newContent

        if (this.codeBlocks[this.activeBlockIndex].source === '') {
          this.codeBlocks[this.activeBlockIndex].source = codeToAdd
        } else {
          this.codeBlocks[this.activeBlockIndex].source += '\n\n' + codeToAdd
        }
        this.handlerChangeCode(this.codeBlocks[this.activeBlockIndex].source)
      },
      createTemplate () {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.newTemplate.runtime = this.hmdFunction.runtime
            FunctionService.createTemplate(this.newTemplate, this)
          }
        })
      },
      checkFunctionDeployed () {
        var t = this
        FunctionService.checkFunctionDeployed(this.hmdFunction.id, this)
          .then(function (response) {
            const runTime = document.getElementById('runtime-button')

            if (response.status === 200) {
              if (response.data !== 'Pending') {
                clearInterval(t.interval)
                t.deployingFunction = false
                runTime.classList.remove(
                  'running',
                  'pending',
                  'crashLoopBackOff'
                )

                if (response.data === 'Running') {
                  runTime.classList.add('running')
                  t.functionDeployed = true
                } else {
                  runTime.classList.add('crashLoopBackOff')
                }
              }
            }
          })
          .catch(() => {
            t.functionDeployed = false
            t.deployingFunction = false

            const runTime = document.getElementById('runtime-button')
            runTime.classList.remove('running', 'pending', 'crashLoopBackOff')
            runTime.classList.add('crashLoopBackOff')
            clearInterval(t.interval)
          })
      },
      handleKeyDown () {
        // Call the "save function" if the user press Ctrl + S (Linux & Windows) or CMD + S (Mac)
        let e = event
        if (
          e.keyCode == 83 &&
          (window.navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)
        ) {
          // Prevent the browser from opening the default shortcut window
          e.preventDefault()
          // Prevent the user from trying to save when the call has already been made
          if (!this.deployingFunction) {
            this.handleSave()
          }
        }
      },
      checkDataUsage () {
        this.useDataInFunction = this.requestData !== ''
        this.isRequestDataJsonFormat = this.isJsonString(this.requestData)
      },
      isJsonString (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      // Called after clicking on the "get Logs" button
      displayLogs: function () {
        // Hide the button, show thethe loader, and change the status icon color to orange
        this.showLogBtn = false
        this.logsDisplayed = false
        const status = document.getElementById('status-icon')

        status.classList.remove('valid', 'pending', 'error')
        status.classList.add('pending')

        this.showRelaunchBtn = false

        const t = this

        FunctionService.getLogs(this.hmdFunction.id, this)
          .then(function (response) {
            // Hide the spinner, display the log panel, change the status color icon to green or red, show the relaunch button
            t.logsDisplayed = true

            const logs = document.getElementById('log-card')
            logs.classList.add('expanded')
            const leftPanel = document.getElementById('log-left')
            leftPanel.style.height = '300px'

            status.classList.replace(
              'pending',
              response.data.serverless_code == 200 ? 'valid' : 'error'
            )

            t.logs = response.data.log

            t.showRelaunchBtn = true

          // response.data.split("\n").forEach(function(log) {
          //   t.logs.push(log)
          // })
          })
          .catch(function (error) {
            t.logsDisplayed = true

            // Hide the spinner, display the log panel, change the status color icon to red, show the relaunch button
            const logs = document.getElementById('log-card')
            logs.classList.add('expanded')
            const leftPanel = document.getElementById('log-left')
            leftPanel.style.height = '300px'

            status.classList.replace('pending', 'error')
            t.showRelaunchBtn = true

            t.logs = 'Unexpected error while retrieving logs :\n' + error
          })
      },
      handleClickLogs: function () {
        if (this.logs === null || this.logs === undefined) {
          this.displayLogs()
        }
      },
      handleClickSearchTemplate: function () {
        this.showSearchTemplates = !this.showSearchTemplates

        // Set the focus on the search field if displayed
        if (this.showSearchTemplates) {
          setTimeout(function () {
            document.getElementById('searchTemplateField').focus()
          })
        }
      },
      handleClickData: function () {
        this.callingBackendData = true
        const t = this
        this.datasetsList = []
        // Retrieves all datasets
        FunctionService.getDataList()
          .then(function (response) {
            response.data.results.forEach(dataset => {
              t.datasetsList.push(dataset)

              // For each dataset, retrieve the return of getData and store it in the "text" attribute in the datasetList of the corresponding dataset
              FunctionService.getData(t.hmdFunction.runtime, dataset.hmd_id)
                .then(function (innerResponse) {
                  t.datasetsList.find(
                    correspondingDataset =>
                      correspondingDataset.name === dataset.name
                  ).text = innerResponse.data
                })
                .catch(function (error) {
                  // We only ignore error caused by an interrupted promise (happens when spamming the tab button)
                  if (error.name !== 'TypeError') {
                    console.error(error)
                  }
                })
            })
          })
          .finally(function () {
            t.callingBackendData = false
          })
      },
      handleClickInsertDataset: function () {
        const t = this
        FunctionService.getData(
          this.hmdFunction.runtime,
          this.datasetListItemSelected
        ).then(function (response) {
          t.addCode(response.data)
        })
      },
      handleClickSearchData: function () {
        this.showSearchData = !this.showSearchData

        // Set the focus on the search field if displayed
        if (this.showSearchData) {
          setTimeout(function () {
            document.getElementById('searchDataField').focus()
          })
        }
      },
      handleClickApi: function () {
        this.callingBackendApi = true
        const t = this
        this.apiList = []
        // Retrieves all APIs
        FunctionService.getApiList()
          .then(function (response) {
            response.data.results.forEach(api => {
              t.apiList.push(api)

              // For each API, retrieve the return of getApi and store it in the "text" attribute in the apiList of the corresponding api
              FunctionService.getApi(t.hmdFunction.runtime, api.name)
                .then(function (innerResponse) {
                  t.apiList.find(
                    correspondingApi => correspondingApi.name === api.name
                  ).text = innerResponse.data
                })
                .catch(function (error) {
                  // We only ignore error caused by an interrupted promise (happens when spamming the tab button)
                  if (error.name !== 'TypeError') {
                    console.error(error)
                  }
                })
            })
          })
          .finally(function () {
            t.callingBackendApi = false
          })
      },
      handleClickSearchApi: function () {
        this.showSearchApi = !this.showSearchApi

        // Set the focus on the search field if displayed
        if (this.showSearchApi) {
          setTimeout(function () {
            document.getElementById('searchApiField').focus()
          })
        }
      },
      handleClickInsertApi: function () {
        const t = this

        FunctionService.getApi(
          this.hmdFunction.runtime,
          this.apiListItemSelected
        ).then(function (response) {
          t.addCode(response.data)
        })
      },
    },
  }
</script>
